<template>
  <section class="section">
    <header class="header">
      <h2>{{ title }}</h2>
      <div
        class="button copy"
        @click.stop="onCopyPlatesButtonClicked"
        v-if="plates.length == 0 || (isEconomic && plates[0]['text'] == '')"
      >
        Cargar últimos platos
      </div>
    </header>
    <div class="section-contents" v-if="plates.length > 0">
      <div
        v-for="(plate, n) in plates"
        :key="`${plate['text']}-${n}`"
        class="plate-container"
      >
        <div class="plate-contents">
          <p>{{ plate["text"] }}</p>
          <div class="plate-allergens-container">
            <img
              v-for="allergenId in plate['allergens']"
              :key="allergenId"
              :src="require(`@/assets/icons/allergens/${allergenId}.svg`)"
              :alt="allergens[allergenId]"
            />
          </div>
        </div>
        <div class="plate-buttons">
          <div @click.stop="onEditButtonClicked(n)" class="button small">
            Editar
          </div>
          <div
            v-if="!isEconomic"
            @click.stop="onDeleteButtonClicked(n)"
            class="button small"
          >
            Borrar
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isEconomic">
      <span class="button" @click.stop="onAddButtonClicked"
        >Añadir {{ title.toLowerCase() }}</span
      >
    </div>
  </section>
</template>

<script>
import json from "@/assets/allergens.json";

export default {
  name: "MenuSection",
  props: {
    isEconomic: Boolean,
    title: {
      type: String,
      required: true,
    },
    section: {
      type: String,
      required: true,
    },
    plates: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      allergens: json,
    };
  },
  methods: {
    onAddButtonClicked() {
      this.$emit("add-plate", this.section);
    },
    onEditButtonClicked(index) {
      this.$emit("edit-plate", this.section, index);
    },
    onDeleteButtonClicked(index) {
      this.$emit("delete-plate", this.section, index);
    },
    onCopyPlatesButtonClicked() {
      this.$emit("copy-plates", this.section);
    },
  },
};
</script>

<style scoped>
.section {
  margin-bottom: 2rem;
}

.section:nth-child(3) {
  margin-bottom: 2rem;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-contents {
  margin: 0.5rem 0;
  box-shadow: 10px 5px 25px -1px rgba(101, 101, 101, 0.15);
  background-color: white;
  border: 1px solid #d2d4d7;
  border-radius: 10px;
}

p {
  margin: 0;
}

.plate-container,
.plate-contents,
.plate-allergens-container,
.plate-buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.plate-container {
  min-height: 3rem;
  padding: 0.3rem;
  border-bottom: 1px solid #e9ebed;
  display: grid;
  grid-template-columns: 1fr auto;
}

.plate-allergens-container img {
  margin: 0 0.25rem;
  width: 1.2rem;
}

.plate-allergens-container img:first-child {
  margin-left: 1rem;
}

.button {
  box-sizing: content-box;
  background-color: rgb(48, 65, 163);
  color: white;
  padding: 0.5rem 1rem;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 900;
  border-radius: 3px;
}

.button:hover {
  cursor: pointer;
  opacity: 0.8;
}

.button.small {
  background-color: rgb(48, 65, 163);
  padding: 0.25rem 0.5em;
  font-size: 0.5rem;
}

.plate-buttons .button:first-child {
  margin-left: 2rem;
  margin-right: 1em;
}
.copy {
  background-color: rgb(58, 161, 26);
}
</style>
